/**
 * Klivlo Go - page behaviour (prefix kgo-).
 *
 * Prices are never hardcoded: they come from the variants printed by
 * kgo-main (#kgo-data). A bundle of N = N units of the chosen variant;
 * Shopify's automatic discounts charge it, taking the % off each unit
 * rounded DOWN to the cent, which bundle() mirrors so page == /cart.js.
 * The cart drawer is drawn from the real cart.
 */
const dataEl = document.getElementById('kgo-data');
const DATA = dataEl ? JSON.parse(dataEl.textContent) : null;
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
const CURRENCY = (DATA && DATA.currency) || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
const LOCALE = (DATA && DATA.locale) || document.documentElement.lang || 'fr-FR';
let nf;
try { nf = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY }); }
catch (e) { nf = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: CURRENCY }); }
const money = (c) => nf.format((Number(c) || 0) / 100);
const fill = (t, m) => Object.keys(m).reduce((s, k) => s.split('[' + k + ']').join(m[k]), t || '');

/* ---------- Christmas: everything marked hides after the end date ---------- */
(function () {
  const end = DATA && DATA.xmasEnd ? Date.parse(DATA.xmasEnd) : NaN;
  if (!isNaN(end) && Date.now() > end) $$('[data-kgo-xmas]').forEach((el) => { el.hidden = true; el.setAttribute('data-kgo-xmas-off', ''); });
})();

/* ---------- Euro figures in copy -> visitor's currency (approximate) ---------- */
(function () {
  const rate = window.Shopify && Shopify.currency && Number(Shopify.currency.rate);
  if (CURRENCY === 'EUR' || !rate) return;
  const whole = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY, maximumFractionDigits: 0 });
  const cents = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY });
  // Big figures round to the nearest 10 ("$890"), small ones keep their
  // cents ("$3.43 a cup") so the maths in the copy still adds up.
  const conv = (n) => {
    const x = parseFloat(String(n).replace(',', '.')) * rate;
    if (x >= 100) return whole.format(Math.round(x / 10) * 10);
    if (x >= 20) return whole.format(Math.round(x));
    return cents.format(Math.round(x * 100) / 100);
  };
  const range = (a, b) => conv(a) + (b ? '-' + conv(b) : '');
  $$('[data-kgo-convert]').forEach((root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement && node.parentElement.closest('[data-kgo-money]')) continue;
      const t = node.nodeValue;
      const out = t
        .replace(/€\s?(\d+(?:[.,]\d+)?)(?:\s?[-–]\s?(\d+(?:[.,]\d+)?))?/g, (_, a, b) => range(a, b))
        .replace(/(\d+(?:[.,]\d+)?)(?:\s?[-–]\s?(\d+(?:[.,]\d+)?))?\s?€/g, (_, a, b) => range(a, b));
      if (out !== t) node.nodeValue = out;
    }
  });
})();

/* ---------- FAQ: one answer open at a time ---------- */
$$('[data-kgo-faq]').forEach((faq) => {
  $$('details', faq).forEach((d) => d.addEventListener('toggle', () => {
    if (d.open) $$('details', faq).forEach((o) => { if (o !== d) o.open = false; });
  }));
});

const cartApi = {
  get: () => fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()),
  post: (path, body) => fetch(ROOT + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
    .then((r) => r.json().then((j) => { if (!r.ok) throw new Error(j.description || j.message || 'cart'); return j; })),
};

const drawer = initDrawer();
if (DATA) initBuy();

/* ================================================================ */
function initBuy() {
  const V = DATA.variants;
  let current = V.find((v) => v.id === DATA.selected) || V[0];
  const configs = [...new Set(V.map((v) => v.config))];
  let tier = Math.max(0, DATA.tiers.findIndex((t) => t.qty === Number(DATA.defaultTier)));
  const T = DATA.text;

  const cmpOf = (v) => (DATA.showCompare && v.compare > v.price ? v.compare : 0);
  function bundle(v, t) {
    const each = v.price - Math.floor(v.price * (t.pct || 0) / 100);
    const total = each * t.qty;
    const cmp = cmpOf(v);
    const full = t.qty === 1 ? (cmp || v.price) : v.price * t.qty;
    return { each, total, full, save: Math.max(0, full - total) };
  }
  const find = (finish, config) => V.find((v) => v.finish === finish && v.config === config);

  /* Gallery */
  const slides = $$('.kgo-stage .kgo-slide');
  const thumbs = $$('[data-kgo-thumb]');
  function show(mediaId) {
    const i = DATA.media.indexOf(Number(mediaId));
    if (i < 0) return;
    slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
    thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
  }
  thumbs.forEach((t) => t.addEventListener('click', () => show(t.getAttribute('data-kgo-thumb'))));

  /* Pickers */
  $$('[data-kgo-finish]').forEach((b) => b.addEventListener('click', () => {
    const v = find(b.getAttribute('data-kgo-finish'), current.config) || V.find((x) => x.finish === b.getAttribute('data-kgo-finish'));
    if (v) { current = v; render(true); }
  }));
  $$('[data-kgo-config]').forEach((b) => b.addEventListener('click', () => {
    const v = find(current.finish, b.getAttribute('data-kgo-config'));
    if (v) { current = v; render(true); }
  }));
  $$('[data-kgo-tier]').forEach((b) => {
    b.addEventListener('click', () => { tier = Number(b.getAttribute('data-kgo-tier')); render(false); });
    b.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      e.preventDefault();
      const n = tier + (e.key === 'ArrowDown' ? 1 : -1);
      if (n >= 0 && n < DATA.tiers.length) { tier = n; render(false); $$('[data-kgo-tier]')[n].focus(); }
    });
  });

  function render(variantChanged) {
    const cmp = cmpOf(current);
    $$('[data-kgo-unit-price]').forEach((el) => { el.textContent = money(current.price); });
    $$('[data-kgo-unit-compare]').forEach((el) => { el.textContent = money(cmp); el.hidden = !cmp; });
    $$('[data-kgo-finish-name]').forEach((el) => { el.textContent = current.finish; });
    $$('[data-kgo-finish]').forEach((b) => b.setAttribute('aria-pressed', b.getAttribute('data-kgo-finish') === current.finish ? 'true' : 'false'));
    const base = find(current.finish, configs[0]) || current;
    $$('[data-kgo-config]').forEach((b) => {
      const name = b.getAttribute('data-kgo-config');
      b.setAttribute('aria-pressed', name === current.config ? 'true' : 'false');
      const v = find(current.finish, name);
      const extra = v ? v.price - base.price : 0;
      const title = $('[data-kgo-config-title]', b);
      if (title) title.textContent = extra > 0 ? fill(T.configExtra, { name, extra: money(extra) }) : name;
    });

    $$('[data-kgo-tier]').forEach((b) => {
      const i = Number(b.getAttribute('data-kgo-tier'));
      const t = DATA.tiers[i];
      const r = bundle(current, t);
      b.setAttribute('aria-checked', i === tier ? 'true' : 'false');
      b.tabIndex = i === tier ? 0 : -1;
      $('[data-kgo-tier-title]', b).textContent = t.qty === 1 ? T.titleSingle : fill(T.titleMulti, { n: t.qty, pct: t.pct });
      $('[data-kgo-tier-sub]', b).textContent = t.qty === 1
        ? (cmp ? fill(T.subSingle, { save: money(r.save) }) : T.subSingleNoCompare)
        : fill(T.subMulti, { each: money(r.each), save: money(r.save) });
      $('[data-kgo-tier-total]', b).textContent = money(r.total);
      const full = $('[data-kgo-tier-full]', b);
      full.textContent = money(r.full);
      full.hidden = r.full <= r.total;
    });

    const t = DATA.tiers[tier];
    const r = bundle(current, t);
    const saving = $('[data-kgo-saving]');
    if (saving) {
      saving.hidden = r.save <= 0;
      saving.innerHTML = fill(T.saving, { save: money(r.save), pct: r.full ? Math.round(r.save * 100 / r.full) : 0 });
    }
    $$('[data-kgo-add]').forEach((b) => {
      b.disabled = !current.available;
      if (!b.dataset.label) b.dataset.label = b.textContent;
      b.textContent = current.available ? b.dataset.label : T.soldOut;
    });
    const label = current.finish + (current.config && current.config !== configs[0] ? ' · ' + current.config : '');
    $$('[data-kgo-sticky-label]').forEach((el) => { el.textContent = label + ' · ' + (t.qty > 1 ? t.qty + ' × · ' : '') + money(r.total); });
    $$('[data-kgo-sticky-img]').forEach((el) => { if (current.img) el.src = current.img; });

    if (variantChanged) {
      if (current.media) show(current.media);
      try { const u = new URL(location.href); u.searchParams.set('variant', current.id); history.replaceState(history.state, '', u); } catch (e) {}
    }
  }
  render(false);

  /* Add to cart */
  $$('[data-kgo-add]').forEach((btn) => btn.addEventListener('click', () => {
    if (!current.available) return;
    const items = [{ id: current.id, quantity: DATA.tiers[tier].qty }];
    const buttons = $$('[data-kgo-add]');
    buttons.forEach((b) => { b.disabled = true; });
    cartApi.post('cart/add.js', { items })
      .then(() => cartApi.get())
      .then((cart) => {
        drawer.startTimer();
        drawer.draw(cart);
        drawer.open(btn);
        const keep = btn.dataset.label || btn.textContent;
        btn.textContent = T.added;
        setTimeout(() => { btn.textContent = keep; }, 1800);
      })
      .catch((e) => { console.error('[kgo] add failed', e); alert(T.error); })
      .finally(() => buttons.forEach((b) => { b.disabled = !current.available; }));
  }));

  /* Sticky bar: visible once the buy box button has scrolled away upwards */
  const sticky = $('[data-kgo-sticky]');
  const mainAdd = $('[data-kgo-main-add]');
  if (sticky && mainAdd && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      const on = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      $$('button', sticky).forEach((b) => { b.tabIndex = on ? 0 : -1; });
    }).observe(mainAdd);
  }
}

/* ================================================================ */
function initDrawer() {
  const el = $('[data-kgo-drawer]');
  const noop = { draw() {}, open() {}, startTimer() {} };
  if (!el) return noop;
  const panel = $('.kgo-panel', el);
  const lines = $('[data-kgo-lines]', el);
  const d = el.dataset;
  const KEY = 'kgo-reserve-until';
  const MS = (Number(d.minutes) || 5) * 60000;
  const compare = {};
  if (DATA) DATA.variants.forEach((v) => { if (DATA.showCompare && v.compare > v.price) compare[v.id] = v.compare; });
  const upsellIds = $$('[data-kgo-upsell]', el).map((b) => Number(b.getAttribute('data-kgo-upsell')));
  let last = null;

  function open(from) {
    last = from || document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('kgo-lock');
    tick();
    panel.focus({ preventScroll: true });
  }
  function close() {
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('kgo-lock');
    if (last && last.focus) last.focus({ preventScroll: true });
  }

  function make(tag, cls, text) { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }

  function draw(cart) {
    const has = cart.item_count > 0;
    $$('[data-kgo-when-items]', el).forEach((n) => { n.hidden = !has || n.hasAttribute('data-kgo-xmas-off'); });
    $('[data-kgo-empty]', el).hidden = has;
    $$('[data-kgo-count]').forEach((n) => { n.textContent = cart.item_count; });
    lines.innerHTML = '';
    let saved = 0;
    let addons = 0;
    cart.items.forEach((it) => {
      const row = make('div', 'kgo-line');
      const img = make('img');
      img.alt = '';
      img.width = 84; img.height = 84; img.loading = 'lazy';
      if (it.image) img.src = it.image + (it.image.includes('?') ? '&' : '?') + 'width=200';
      row.appendChild(img);
      const body = make('div', 'kgo-line-body');
      const top = make('div', 'kgo-line-top');
      top.appendChild(make('span', 'kgo-line-title', it.product_title));
      const prices = make('span', 'kgo-line-prices');
      prices.appendChild(make('span', 'kgo-line-total', money(it.final_line_price)));
      const discounted = it.original_line_price > it.final_line_price;
      const full = discounted ? it.original_line_price : (compare[it.variant_id] ? compare[it.variant_id] * it.quantity : 0);
      if (full > it.final_line_price) {
        prices.appendChild(make('span', 'kgo-line-was', money(full)));
        prices.appendChild(make('span', 'kgo-line-save', fill(d.save, { save: money(full - it.final_line_price) })));
        saved += full - it.final_line_price;
      }
      top.appendChild(prices);
      body.appendChild(top);
      if (!it.product_has_only_default_variant && it.variant_title) body.appendChild(make('span', 'kgo-line-meta', it.variant_title));
      if (discounted) {
        const pct = Math.round((it.original_line_price - it.final_line_price) * 100 / it.original_line_price);
        body.appendChild(make('span', 'kgo-line-deal', fill(d.deal, { pct })));
      }
      if (upsellIds.includes(it.variant_id)) addons += it.final_line_price;
      const ctrl = make('div', 'kgo-line-ctrl');
      const step = make('div', 'kgo-step');
      const minus = make('button', null, '−'); minus.type = 'button'; minus.setAttribute('aria-label', d.minus);
      const plus = make('button', null, '+'); plus.type = 'button'; plus.setAttribute('aria-label', d.plus);
      minus.addEventListener('click', () => change(it.key, it.quantity - 1));
      plus.addEventListener('click', () => change(it.key, it.quantity + 1));
      step.append(minus, make('span', null, it.quantity), plus);
      const rm = make('button', 'kgo-remove', d.remove); rm.type = 'button';
      rm.addEventListener('click', () => change(it.key, 0));
      ctrl.append(step, rm);
      body.appendChild(ctrl);
      row.appendChild(body);
      lines.appendChild(row);
    });
    $('[data-kgo-subtotal]', el).textContent = money(cart.total_price);
    const saveRow = $('[data-kgo-save-row]', el);
    if (saveRow) { saveRow.hidden = saved <= 0; $('[data-kgo-save]', el).textContent = '−' + money(saved); }
    const addRow = $('[data-kgo-addon-row]', el);
    if (addRow) { addRow.hidden = addons <= 0; $('[data-kgo-addons]', el).textContent = money(addons); }
    $$('[data-kgo-upsell]', el).forEach((b) => {
      const inCart = cart.items.some((it) => it.variant_id === Number(b.getAttribute('data-kgo-upsell')));
      b.setAttribute('aria-pressed', inCart ? 'true' : 'false');
      b.textContent = inCart ? d.added : d.add;
    });
    const wrap = $('[data-kgo-wrap]', el);
    const wrapOn = cart.attributes && cart.attributes['Gift wrap'] === 'Yes';
    if (wrap) wrap.setAttribute('aria-checked', wrapOn ? 'true' : 'false');
    const wrapRow = $('[data-kgo-wrap-row]', el);
    if (wrapRow) wrapRow.hidden = !wrapOn;
    if (!has) { try { localStorage.removeItem(KEY); } catch (e) {} }
    tick();
  }

  function change(key, quantity) {
    el.classList.add('is-busy');
    cartApi.post('cart/change.js', { id: key, quantity: Math.max(0, quantity) })
      .then(draw)
      .catch((e) => console.error('[kgo] change failed', e))
      .finally(() => el.classList.remove('is-busy'));
  }

  $$('[data-kgo-upsell]', el).forEach((b) => b.addEventListener('click', () => {
    const id = Number(b.getAttribute('data-kgo-upsell'));
    el.classList.add('is-busy');
    cartApi.get().then((cart) => {
      const line = cart.items.find((it) => it.variant_id === id);
      return line ? cartApi.post('cart/change.js', { id: line.key, quantity: 0 }) : cartApi.post('cart/add.js', { items: [{ id, quantity: 1 }] }).then(() => cartApi.get());
    }).then(draw).catch((e) => console.error('[kgo] upsell failed', e)).finally(() => el.classList.remove('is-busy'));
  }));

  const wrapBtn = $('[data-kgo-wrap]', el);
  if (wrapBtn) wrapBtn.addEventListener('click', () => {
    const on = wrapBtn.getAttribute('aria-checked') !== 'true';
    cartApi.post('cart/update.js', { attributes: { 'Gift wrap': on ? 'Yes' : '' } }).then(draw);
  });

  /* Reservation timer: cosmetic, starts at the first add, survives reloads,
     never removes anything. At 0:00 it shows the "ended" message. */
  function startTimer() {
    try { const u = Number(localStorage.getItem(KEY)); if (!u || u < Date.now() - 86400000) localStorage.setItem(KEY, String(Date.now() + MS)); } catch (e) {}
  }
  function tick() {
    let until = 0;
    try { until = Number(localStorage.getItem(KEY)); } catch (e) {}
    const has = !$('[data-kgo-empty]', el).hidden ? false : true;
    const left = until ? Math.max(0, Math.round((until - Date.now()) / 1000)) : 0;
    $('[data-kgo-timer]', el).hidden = !(has && until && left > 0);
    $('[data-kgo-timer-end]', el).hidden = !(has && until && left === 0);
    const v = $('[data-kgo-timer-value]', el);
    if (v) v.textContent = Math.floor(left / 60) + ':' + String(left % 60).padStart(2, '0');
  }
  setInterval(() => { if (el.classList.contains('is-open')) tick(); }, 1000);

  $$('[data-kgo-close]', el).forEach((b) => b.addEventListener('click', close));
  document.addEventListener('keydown', (e) => {
    if (!el.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    const f = $$('button, a[href], [tabindex]:not([tabindex="-1"])', panel).filter((n) => !n.disabled && n.offsetParent !== null);
    if (!f.length) return;
    if (e.shiftKey && (document.activeElement === f[0] || document.activeElement === panel)) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  /* Header "Cart" and any theme cart link open this drawer: one cart UI. */
  window.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('[data-kgo-open-cart], [data-testid="cart-drawer-trigger"], a[href$="/cart"]');
    if (!t || el.contains(t)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    cartApi.get().then((cart) => { draw(cart); open(t); });
  }, true);

  cartApi.get().then(draw).catch(() => {});
  return { draw, open, startTimer };
}
